import {Component, Injector, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {AbstractNgModelComponent} from './ng-model.component';
import {AppService} from 'app/services/app.service';
import {SwitchCheckboxCollection, SwitchRadioCollection} from 'app/entities/switchCollection.entity';
import {Subscription} from 'rxjs';

@Component({template: ''})
export class AbstractSwitchesComponent<T = (SwitchCheckboxCollection | SwitchRadioCollection)> extends AbstractNgModelComponent<(string | number) | (string | number)[]> implements OnInit, OnDestroy {

  // @TODO SAKURA-112 add debounce

  @Input() debounce = 0;

  appService: AppService;
  debounceTimer: any;
  collectionChangeSubscribe: Subscription = null;
  ignoreFirstWriteValue = true;
  firstValueSet = false;

  protected _collection: T & (SwitchCheckboxCollection | SwitchRadioCollection);
  private formBuilder: FormBuilder;

  get collection(): T & (SwitchCheckboxCollection | SwitchRadioCollection) {
    return this._collection;
  }

  @Input() set collection(collection: T & (SwitchCheckboxCollection | SwitchRadioCollection)) {
    this._collection = collection;
    if (this._collection) {
      if (this.collectionChangeSubscribe) {
        this.collectionChangeSubscribe.unsubscribe();
      }

      this.collectionChangeSubscribe = this._collection.onChange.subscribe(() => {
        this.value = this._collection.getSelectedId();
      });

      if (this.firstValueSet) {
        this.value = this._collection.getSelectedId();
      }

      this.firstValueSet = true;
    }
  }

  // @TODO fix tslint for constructor ordering
  // eslint-disable-next-line @typescript-eslint/member-ordering
  constructor(
    injector: Injector,
    appService: AppService
  ) {
    super(injector);

    this.appService = appService;
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.collectionChangeSubscribe) {
      this.collectionChangeSubscribe.unsubscribe();
    }
  }

  writeValue(value): void {
    if (this.ignoreFirstWriteValue) {
      this.ignoreFirstWriteValue = false;
      if (value === null) {

        setTimeout(() => {
          this.value = this.collection.getSelectedId();
        }, 0);
        return;
      }
    }

    // fix for stupid profile
    if (value && Array.isArray(value) && typeof value[0] === 'object') {
      value = value.map(item => item.id);
    }

    this.collection.itemSelect(value, true, true);
  }

  public emitEvents() {
    if (this.debounce) {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      this.debounceTimer = setTimeout(() => {
        this.makeEmitEvents();
      }, this.debounce);
    } else {
      this.makeEmitEvents();
    }
  }

  public makeEmitEvents() {
    this.notifyValueChange();
    this.onTouchModel();
  }

}
